export const COLLECTION_PLANEJAMENTO_RECURSOS = "tblPlanejamentosRecursos";

export const CAMPOS_RECURSO = [
  ["categoria", "Categoria de recurso"],
  ["descricao", "Descrição detalhada"],
  ["quantidade", "Quantidade necessária"],
  ["responsavel", "Responsável"],
  ["investimento", "Investimento R$"],
  ["periodicidade", "Periodicidade"],
  ["status", "Status"],
];

const recurso = (categoria, descricao, quantidade, responsavel, investimento = "", periodicidade = "", status = "Atendido") => ({
  categoria,
  descricao,
  quantidade,
  responsavel,
  investimento,
  periodicidade,
  status,
});

export const RECURSOS_INICIAIS = [
  recurso("Pessoas", "Técnicos de laboratório capacitados em moldagem e ensaios", "3", "RH / Eng. Responsável"),
  recurso("Pessoas", "Engenheiro responsável técnico (CREA ativo)", "1", "Diretoria"),
  recurso("Pessoas", "Técnico de Segurança", "1", ""),
  recurso("Infraestrutura", "Laboratório físico com sala de ensaio", "1", "Manutenção / SGQ"),
  recurso("Infraestrutura", "Veículo para coleta de amostras", "1", "Frota / Logística"),
  recurso("Ambiente", "Controle de temperatura na sala de cura (20 ± 2 °C)", "1 sistema", "SGQ / Técnico de laboratório"),
  recurso("Segurança", "Equipamentos de EPI/EPC para colaboradores (luvas, óculos, protetores)", "100% equipe atendida", "RH / Segurança do Trabalho"),
  recurso("Segurança", "Extintores em pontos estratégicos", "100% equipe atendida", "RH / Segurança do Trabalho"),
  recurso("Equipamentos de Medição e Monitoramento", "Equipamentos de medição devidamente calibrados e com certificado válido", "1", "SGQ / Metrologia"),
  recurso("Conhecimento Organizacional", "POPs atualizados (ex.: POP 1.1 e POP 1.2)", "Todos", "SGQ"),
  recurso("Conhecimento Organizacional", "Normas ABNT aplicáveis (ex.: NBR 5738, 5739, 7212, 16886)", "Todas vigentes", "SGQ"),
  recurso("Financeiro", "Fundo para aquisição de novos equipamentos, manutenção, calibração e despesas não previstas", "1", "Diretoria Financeira"),
  recurso("Financeiro", "Investimento em treinamentos técnicos", "1", "RH / SGQ"),
  recurso("Financeiro", "Verba para auditorias externas (ISO 9001)", "1", "RH / SGQ", "7.000,00", "Anual"),
  recurso("Financeiro", "Consultoria do SGQ / Sebrae 60%", "", "", "20.000,00"),
  recurso("Administrativo", "Sala administrativa", "1", "Silvio"),
  recurso("Tecnológico", "Computador, impressora e dados em nuvem", "1", "Silvio"),
  recurso("Tecnológico", "Computadores, software de gestão laboratorial ou planilhas estruturadas", "1", "Silvio"),
  recurso("Tecnológico", "Acesso ao Target (sistema para acesso a normas ABNT)", "1", "José Carlos", "1.000,00"),
  recurso("Tecnológico", "Manutenção do site", "1", "Silvio"),
  recurso("Área de operações", "Área coberta para armazenamento de materiais, sala de ensaios, bancadas, rede elétrica estabilizada, extintores e equipamentos de segurança", "1", "José Carlos"),
  recurso("Alimentação", "Café da manhã no laboratório", "1", "Silvio", "1.500,00", "Mensal"),
];

export function novoRecurso() {
  return {
    ...Object.fromEntries(CAMPOS_RECURSO.map(([campo]) => [campo, ""])),
    status: "Planejado",
  };
}
